import { makeAutoObservable, runInAction } from "mobx";
import { apiGet } from "../utils/fetch";
import type { UserInterface, GenericResponseInterface } from "../interfaces/interfaces";

class UsersStore {
  users: UserInterface[] = [];
  loading = false;
  error: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  async loadUsers() {
    this.loading = true;
    this.error = null;
    try {
      const result = await apiGet<GenericResponseInterface<UserInterface[]>>('/users');
      runInAction(() => {
        if (result.status && result.data) {
          this.users = result.data;
        } else {
          this.error = result.message || 'Failed to fetch users';
        }
        this.loading = false;
      });
    } catch (err: any) {
      runInAction(() => {
        this.error = err.message || 'Failed to fetch users';
        this.loading = false;
      });
    }
  }

  setUsers(users: UserInterface[]) {
    this.users = users;
  }
}

const usersStore = new UsersStore();
export default usersStore;